import React from 'react'


export default function PDFViewer({pdf}) {
  return (
    <a href= {pdf} target = "_blank" className="box-center">Schedule Pdf</a>
)
}
